import r2wc from '@r2wc/react-to-web-component';
import { StatsigProvider } from '@statsig/react-bindings';

import { useEssentialProps } from '../../../apps/explore/components/AppWrapper/_app.hooks';
import { AuthModalProvider } from '../../../apps/explore/providers/AuthModalProvider';
import { MarketProvider } from '../../../apps/explore/providers/MarketProvider';
import { TranslationProvider } from '../../../apps/explore/providers/TranslationProvider';
import {
  type SembonusUserInfo,
  UserProvider,
} from '../../../apps/explore/providers/UserProvider';
import { getMarket } from '../../../apps/explore/utils/markets';
import { Content } from './components/Content';
import { DEFAULT_SEMBO_MARKET } from './constants';
import { useStatsigClient } from './hooks';
import { WidgetStyles } from './WidgetStyles';

const SemboAuthModal = () => {
  const market = getMarket(window.location.host) ?? DEFAULT_SEMBO_MARKET;

  const { microcopy } = useEssentialProps({ market });
  const { client } = useStatsigClient(market);

  const onLoggedIn = (user: SembonusUserInfo | undefined) => {
    window.dispatchEvent(
      new CustomEvent('semboUserLoggedIn', {
        detail: { user },
        bubbles: true,
      })
    );
  };

  if (!microcopy) {
    return null;
  }

  return (
    <MarketProvider market={market}>
      <StatsigProvider client={client}>
        <UserProvider>
          <AuthModalProvider onLoggedIn={onLoggedIn}>
            <TranslationProvider microcopy={microcopy} lang={market.lang}>
              <WidgetStyles />

              <Content />
            </TranslationProvider>
          </AuthModalProvider>
        </UserProvider>
      </StatsigProvider>
    </MarketProvider>
  );
};

customElements.define('sembo-auth', r2wc(SemboAuthModal));
